var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7932_37731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3327 16.2683V8.33333C28.3327 3.73167 24.6027 0 19.9993 0C15.3943 0 11.666 3.73167 11.666 8.33333V16.2683C8.62102 18.7117 6.66602 22.4583 6.66602 26.6667C6.66602 34.03 12.636 40 19.9993 40C27.3627 40 33.3327 34.03 33.3327 26.6667C33.3327 22.4583 31.3777 18.7117 28.3327 16.2683ZM14.9993 8.33333C14.9993 5.57667 17.2427 3.33333 19.9993 3.33333C22.756 3.33333 24.9993 5.57667 24.9993 8.33333V14.3117C23.4543 13.685 21.7693 13.3333 19.9993 13.3333C18.2293 13.3333 16.5443 13.685 14.9993 14.3117V8.33333ZM19.9993 36.6667C14.4843 36.6667 9.99935 32.1817 9.99935 26.6667C9.99935 21.1517 14.4843 16.6667 19.9993 16.6667C25.5143 16.6667 29.9993 21.1517 29.9993 26.6667C29.9993 32.1817 25.5143 36.6667 19.9993 36.6667ZM23.3327 26.6667C23.3327 28.5067 21.8393 30 19.9993 30C18.1593 30 16.666 28.5067 16.666 26.6667C16.666 24.8267 18.1593 23.3333 19.9993 23.3333C21.8393 23.3333 23.3327 24.8267 23.3327 26.6667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7932_37731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5095e311f55ff403b162f631c1dfda0d.svg";
export { ForwardRef as ReactComponent };